import React from "react";

/** Cancelled — same numeric code used when hiding pay on public installation summary. */
export const INSTALLATION_ORDER_CANCELLED_STATUS_CODE = 600;

// Maps for status and priority labels
export const STATUS_MAP: { [key: number]: string } = {
  100: "Draft",
  // 101: "Confirmed",
  200: "Finalized",
  300: "Scheduled",
  // 301: "Shipped",
  // 302: "Delivered",
  400: "In Progress",
  // 401: "Completed",
  500: "Completed",
  // 600: "Closed",
  600: "Cancelled",
  // 700: "Lost",
};

export const PRIORITY_LABELS: { [key: number]: string } = {
  1: "High",
  2: "Medium",
  3: "Low",
};

/* -------- chip palette (by name) — aligned with SalesOrderstatus (quote / order labels) -------- */
const paymentStatusColors: Record<string, { bg: string; color: string }> = {
  "Partial Payment": { bg: "#ffeacc", color: "#cc8400" },
  Paid: { bg: "#d2f5d2", color: "#2a6b2a" },
  Pending: { bg: "#ffe0b3", color: "#b76b00" },
  Overpaid: { bg: "#e0cfff", color: "#6b21a8" },
  Overdue: { bg: "#ffe2e2", color: "#9f0712" },
};

const orderStatusColors: Record<string, { bg: string; color: string }> = {
  Draft:        { bg: "#e5e7eb", color: "#4b5563" },
  Quote: { bg: "#e5e7eb", color: "#4b5563" },
  Finalized:    { bg: "#d9f2ff", color: "#2563eb" },
  Scheduled:    { bg: "#e0f7fa", color: "#00838f" },
  "In Progress":{ bg: "#ffe3c7", color: "#92400e" },
  Completed:    { bg: "#d2f5d2", color: "#2a6b2a" },
  Cancelled:    { bg: "#fddede", color: "#d93025" },

  // Draft: { bg: "#e5e7eb", color: "#4b5563" },
  // Quote: { bg: "#e5e7eb", color: "#4b5563" },
  // Confirmed: { bg: "#fff7c2", color: "#a6b800" },
  // Shipped: { bg: "#cfe8fc", color: "#276ada" },
  // Cancelled: { bg: "#fddede", color: "#d93025" },
  // Delivered: { bg: "#d2f5d2", color: "#368727" },
  // Completed: { bg: "#d2f5d2", color: "#2a6b2a" },
  // "Partial Payment": { bg: "#ffeacc", color: "#cc8400" },
  // Paid: { bg: "#d2f5d2", color: "#2a6b2a" },
  // Pending: { bg: "#ffe0b3", color: "#b76b00" },
  // Overpaid: { bg: "#e0cfff", color: "#6b21a8" },
  // Overdue: { bg: "#ffe2e2", color: "#9f0712" },
  // Finalized: { bg: "#d9f2ff", color: "#2563eb" },
  // Scheduled: { bg: "#e0f7fa", color: "#00838f" },
  // "In-Progress": { bg: "#ffe3c7", color: "#92400e" },
  // "In Progress": { bg: "#ffe3c7", color: "#92400e" },
  // Lost: { bg: "#fcdcdc", color: "#b91c1c" },
  // keep any others you show in UI here, mapped by label:
  // Closed / Lost were commented out in STATUS_MAP, so omitted here
};

const priorityColors: Record<string, { bg: string; color: string }> = {
  High:   { bg: "#ffe0e0", color: "#d93025" },
  Medium: { bg: "#e0f0ff", color: "#276ada" },
  Low:    { bg: "#d2f5d2", color: "#368727" },
};

/* -------- base chip style (no font weight) -------- */
const CHIP_BASE: React.CSSProperties = {
  display: "inline-block",
  padding: "3px 7px",
  borderRadius: "0.525rem",
  fontSize: "0.75rem",
  textAlign: "center",
};

// StatusBadge component props
interface StatusBadgeProps {
  value: number | string | undefined;
  type: "payment" | "order" | "priority";
}

export const InstallationStatusBadge: React.FC<StatusBadgeProps> = ({ value, type }) => {
  if (value === undefined || value === null || value === "") return <span>—</span>;

  let bgColor = "#E2E3E5";
  let textColor = "#383D41";
  let label = typeof value === "string" ? value : "";

  if (type === "payment" && typeof value === "string") {
    const c = paymentStatusColors[value];
    if (c) {
      bgColor = c.bg;
      textColor = c.color;
    }
  } else if (type === "order") {
    if (typeof value === "number") {
      label = STATUS_MAP[value] || "Unknown";
      const c = orderStatusColors[label];
      if (c) {
        bgColor = c.bg;
        textColor = c.color;
      }
    } else if (typeof value === "string") {
      const orderLabel = value === "Quote" ? "Draft" : value;
      label = orderLabel;
      const c = orderStatusColors[orderLabel];
      if (c) {
        bgColor = c.bg;
        textColor = c.color;
      }
    }
  } else if (type === "priority" && typeof value === "string") {
    const c = priorityColors[value];
    if (c) {
      bgColor = c.bg;
      textColor = c.color;
    }
  }

  const style: React.CSSProperties = {
    ...CHIP_BASE,
    backgroundColor: bgColor,
    color: textColor,
    border: "0.2px solid",
    borderColor: `${textColor}50`,
  };

  return <div style={style}>{label}</div>;
};















// import React from "react";

// // Maps for status and priority labels
// export const STATUS_MAP: { [key: number]: string } = {
//   100: "Draft",
//   // 101: "Confirmed",
//   200: "Finalized",
//   300: "Scheduled",
//   // 301: "Shipped",
//   // 302: "Delivered",
//   400: "In Progress",
//   // 401: "Completed",
//   500: "Completed",
//   // 600: "Closed",
//   600: "Cancelled",
//   // 700: "Lost",
// };

// export const PRIORITY_LABELS: { [key: number]: string } = {
//   1: "High",
//   2: "Medium",
//   3: "Low",
// };

// // Color styles for Payment Status
// const paymentStatusColors: Record<string, { bg: string; color: string }> = {
//   "Partial Payment": { bg: "#FFF3CD", color: "#856404" }, // Payment Pending style
//   "Paid": { bg: "#D4EDDA", color: "#155724" },            // Payment Accepted style
//   "Pending": { bg: "#FFF3CD", color: "#856404" },         // Payment Pending style
// };

// // Color styles for Order Status
// const orderStatusColors: Record<string, { bg: string; color: string }> = {
//   Draft: { bg: "#D3D3D3", color: "#000000" },
//   Finalized: { bg: "#CCE5FF", color: "#004085" },
//   Scheduled: { bg: "#B8DAFF", color: "#004085" },
//   "In Progress": { bg: "#FFF3CD", color: "#856404" },
//   Completed: { bg: "#C3E6CB", color: "#155724" },
//   Closed: { bg: "#c8d4efff", color: "#e13f0aff" },
//   Cancelled: { bg: "#F8D7DA", color: "#721C24" },
//   Lost: { bg: "#f8949eff", color: "#3a3a3aff" },
// };

// // Color styles for Priority
// const priorityColors: Record<string, { bg: string; color: string }> = {
//   High: { bg: "#F6C6C7", color: "#842029" },
//   Medium: { bg: "#FFD966", color: "#7A6000" },
//   Low: { bg: "#D9EAD3", color: "#274E13" },
// };

// const paymentBaseStyle = {
//   display: "inline-block",
//   padding: "4px 12px",
//   fontSize: "14.5px",
//   fontWeight: 500,
//   borderRadius: "20px",
//   border: "1px solid transparent",
//   textAlign: "center" as const,
// };

// const orderBaseStyle = {
//   fontSize: "13px",
//   padding: "6px 14px",
//   borderRadius: "10px",
//   display: "inline-block",
//   fontWeight: 500,
//   textAlign: "center" as const,
// };

// const priorityBaseStyle = {
//   fontSize: "13px",
//   padding: "6px 12px",
//   borderRadius: "6px",
//   display: "inline-block",
//   fontWeight: 500,
//   textAlign: "center" as const,
// };

// // StatusBadge component props
// interface StatusBadgeProps {
//   value: number | string | undefined;
//   type: "payment" | "order" | "priority";
// }

// export const InstallationStatusBadge: React.FC<StatusBadgeProps> = ({ value, type }) => {
//   if (value === undefined || value === null || value === "") {
//     return <span>—</span>;
//   }

//   let bgColor = "#E2E3E5";
//   let textColor = "#383D41";
//   let label = "";

//   if (type === "payment" && typeof value === "string") {
//     label = value;
//     const colors = paymentStatusColors[value];
//     if (colors) {
//       bgColor = colors.bg;
//       textColor = colors.color;
//     }
//   } else if (type === "order" && typeof value === "number") {
//     label = STATUS_MAP[value] || "Unknown";
//     const colors = orderStatusColors[label];
//     if (colors) {
//       bgColor = colors.bg;
//       textColor = colors.color;
//     }
//   } else if (type === "priority" && typeof value === "string") {
//     label = ` ${value}`;
//     const colors = priorityColors[value];
//     if (colors) {
//       bgColor = colors.bg;
//       textColor = colors.color;
//     }
//   }

//   const style =
//     type === "payment"
//       ? { ...paymentBaseStyle, backgroundColor: bgColor, color: textColor }
//       : type === "order"
//       ? { ...orderBaseStyle, backgroundColor: bgColor, color: textColor }
//       : { ...priorityBaseStyle, backgroundColor: bgColor, color: textColor };

//   return <div style={style}>{label}</div>;
// };
